import {
  ToastCloseButton,
  ToastContent,
  ToastDescription,
  ToastTitle,
  Toast as UiToast,
} from "@imi/ui/components/Toast/Toast.js";
import { useEffect, useState } from "react";
import { ToastMessage } from "./ToastContext";

type IToastProps = {
  removeToast?: () => void;
} & ToastMessage;

export function Toast({ removeToast, ...toast }: IToastProps) {
  const [showToast, setShowToast] = useState(true);

  function close() {
    setShowToast(false);
    setTimeout(() => {
      removeToast?.();
    }, 300);
  }

  useEffect(() => {
    const timeout = setTimeout(close, toast.duration ?? 5000);
    return () => {
      clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toast.duration]);

  return (
    <UiToast duration={toast.duration} onClick={removeToast} show={showToast}>
      <ToastContent>
        {toast.title && <ToastTitle>{toast.title}</ToastTitle>}
        <ToastDescription>{toast.message}</ToastDescription>
      </ToastContent>
      <ToastCloseButton />
    </UiToast>
  );
}
